"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonActionSubtle = exports.ButtonActionEmphasis = exports.ButtonActionDefault = exports.ButtonAction = void 0;
var PropTypes = require("prop-types");
var React = require("react");
/**
 * ButtonAction
 */
exports.ButtonAction = React.forwardRef(function (props, ref) {
    var children = props.children, variant = props.variant, attributes = __rest(props, ["children", "variant"]);
    var variants = [
        'emphasis',
        'subtle',
        // Note: "default" is not included in the classname
    ];
    // Add button classname
    attributes.className +=
        variants.indexOf(variant) !== -1
            ? ' btn-action--' + variant
            : ' btn-action';
    // Remove leading space when className is empty
    attributes.className = attributes.className.trim();
    if (props.href) {
        if (props.target === '_blank') {
            attributes.rel = 'noopener noreferrer';
            attributes.target = '_blank';
        }
        return (React.createElement("a", __assign({}, attributes, { ref: ref }), children));
    }
    if (typeof attributes.type === 'undefined') {
        attributes.type = 'button';
    }
    return (React.createElement("button", __assign({}, attributes, { ref: ref }), children));
});
exports.ButtonAction.displayName = 'ButtonAction';
exports.ButtonAction.defaultProps = {
    className: '',
    variant: 'default',
};
exports.ButtonAction.propTypes = {
    className: PropTypes.string,
    href: PropTypes.string,
    id: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['button', 'reset', 'submit', '']),
    variant: PropTypes.oneOf(['default', 'emphasis', 'subtle']),
};
var ButtonActionDefault = function (props) {
    return (React.createElement(exports.ButtonAction, __assign({}, props, { variant: "default" })));
};
exports.ButtonActionDefault = ButtonActionDefault;
var ButtonActionEmphasis = function (props) {
    return (React.createElement(exports.ButtonAction, __assign({}, props, { variant: "emphasis" })));
};
exports.ButtonActionEmphasis = ButtonActionEmphasis;
var ButtonActionSubtle = function (props) {
    return (React.createElement(exports.ButtonAction, __assign({}, props, { variant: "subtle" })));
};
exports.ButtonActionSubtle = ButtonActionSubtle;
